import React from "react"
import { Link } from "gatsby"
import { useCompanyData } from "hooks/use-company-data"
import { useResponsiveValue } from "@theme-ui/match-media"
import styled from "@emotion/styled"
const LogoWrapper = styled.div`
    align-self: end;
    text-align: center;
`
const Logo = () => {
    const company = useCompanyData()
    const LogoWidth = useResponsiveValue([75, 75, 75, 75, 75, 100, 100, 100])
    return (
        <LogoWrapper>
            <Link to="/">
                <img src={company.company_logo.publicURL} width={LogoWidth} alt="" />
            </Link>
        </LogoWrapper>
    )
}

export default Logo
